var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('registerCustomer',{attrs:{"is_request":true,"is_page":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }